import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'
import config from './../config/index'
import axios from 'axios'

// Configure request setup
const serviceName = 'MediaService'
const host = config.mediaServiceUrl
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const MediaService = {
  uploadToBucket: (file: File, signedUrl: string) => {
    return axios.put(signedUrl, file, {
      headers: {
        'Content-Type': file.type,
        'Access-Control-Allow-Origin': '*',
      },
    })
  },
  
  verify: (aknId: string, locationId: string) => {
    const body = {
      altType: 'location',
      altId: locationId,
      id: aknId,
    }
    return request().post('/files/verify', body).then(responseBody)
  }
}

export const mediaService = MediaService

export default {}